// extracted by mini-css-extract-plugin
export default {"wrapper":"TextArea_wrapper__bVEDW","label":"TextArea_label__tTyWQ","textarea":"TextArea_textarea__7U8-r","error":"TextArea_error__Nfhh1","resize":"TextArea_resize__pD7Ly"};